import { memo } from "react";

import classnames from "classnames";
import { hyphenate } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Tag, Typography } from "neetoui";
import { omit } from "ramda";
import { useTranslation } from "react-i18next";
import { withRouter, Link } from "react-router-dom";

import { UNSUPPORTED_LINK_PROPS } from "./constants";
import "./settings.scss";

const IntegrationItem = ({
  icon: Icon = null,
  description,
  label,
  path,
  href,
  isConnected,
  isMobileOrTablet = false,
  className = "",
  ...otherProps
}) => {
  const { t } = useTranslation();

  const commonProps = {
    "data-testid": `${hyphenate(label).replace(/\./g, "-")}-integration-card`,
    className: classnames(
      "neeto-molecules-settings-link relative neeto-ui-rounded-lg neeto-ui-border-gray-300 lg:flex-row flex-col flex cursor-pointer items-start gap-3 xl:gap-4 border px-6 md:py-8 py-6 no-underline outline-none transition-shadow duration-300 ease-in-out",
      className
    ),
    ...omit(UNSUPPORTED_LINK_PROPS, otherProps),
  };

  const LinkElement = href ? "a" : Link;
  const linkProps = href
    ? { href, ...commonProps }
    : { to: path, ...commonProps };

  return (
    <LinkElement {...linkProps}>
      {Icon && (
        <div className="neeto-ui-rounded-lg neeto-ui-shadow-xs neeto-ui-border-gray-200 mt-0.5 flex shrink-0 items-center justify-center border p-1.5 xl:p-2.5">
          <Icon
            data-testid={`${joinHyphenCase(label)}-integration-icon`}
            size={isMobileOrTablet ? 26 : 32}
          />
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <Typography
          className="neeto-molecules-settings-item-heading neeto-ui-text-black transition-color text-lg leading-6 duration-300 ease-in-out"
          data-testid="settings-item-heading"
          style="h3"
          weight="semibold"
        >
          {label}
        </Typography>
        <Typography
          className="neeto-ui-text-gray-600"
          data-testid="settings-item-description"
          style="body2"
        >
          {description}
        </Typography>
      </div>
      {isConnected && (
        <Tag
          className="neeto-ui-text-primary-800 absolute top-2 right-2"
          data-testid="integration-status-tag"
          indicatorStyle="primary"
          label={t("neetoMolecules.integrationCard.connected")}
          style="success"
        />
      )}
    </LinkElement>
  );
};

export default memo(withRouter(IntegrationItem));
